// extracted by mini-css-extract-plugin
export default {"video":"App_video__A3LxI","videoButton":"App_videoButton__VSywO","copy":"App_copy__EXv+4","copyContainer":"App_copyContainer__qIeSP"};